
        import 'CaptureOtherLife.e6417b8.css-module'
        export default {"CaptureOtherLife":"CaptureOtherLife_CaptureOtherLife_e6417b8","email":"email_CaptureOtherLife_e6417b8","optIns":"optIns_CaptureOtherLife_e6417b8","toggle":"toggle_CaptureOtherLife_e6417b8","cancel":"cancel_CaptureOtherLife_e6417b8"}
    